function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { Button as MaterialButton, CircularProgress } from '@material-ui/core';
import PropTypes from 'prop-types';
import React from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import { buttonStyle, buttonClassNameDefinition } from "./styles";
var useStyles = makeStyles(buttonStyle);
export var Button = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var submitting = _ref.submitting,
      fullWidth = _ref.fullWidth,
      disabled = _ref.disabled,
      customVariant = _ref.customVariant,
      margin = _ref.margin,
      type = _ref.type,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'medium' : _ref$size,
      children = _ref.children,
      className = _ref.className,
      variant = _ref.variant,
      _ref$disableElevation = _ref.disableElevation,
      disableElevation = _ref$disableElevation === void 0 ? true : _ref$disableElevation,
      props = _objectWithoutProperties(_ref, ["submitting", "fullWidth", "disabled", "customVariant", "margin", "type", "size", "children", "className", "variant", "disableElevation"]);

  var classes = useStyles();
  var classdef = buttonClassNameDefinition(classes, margin, customVariant);
  return /*#__PURE__*/React.createElement(MaterialButton, _extends({
    type: type,
    classes: {
      label: classes.buttonSpan
    },
    className: clsx(className, classdef),
    fullWidth: fullWidth,
    disabled: disabled || submitting,
    size: size,
    ref: ref,
    variant: customVariant ? 'contained' : variant,
    disableElevation: disableElevation
  }, props), submitting && /*#__PURE__*/React.createElement(CircularProgress, {
    "data-testid": "button-loading",
    size: 20
  }), children);
});
Button.defaultProps = {
  submitting: false,
  margin: false,
  fullWidth: false,
  customVariant: undefined,
  disableElevation: true,
  type: 'submit',
  size: 'medium'
};
Button.propTypes = {
  /** Predefined custom button */
  customVariant: PropTypes.oneOf(['default', 'success', 'warning', 'error', 'contrast']),

  /** Button disabled during form submission */
  submitting: PropTypes.bool,

  /** Button elevation disabled */
  disableElevation: PropTypes.bool,

  /** Button fill div/screen width */
  fullWidth: PropTypes.bool,

  /** Button CSS margin */
  margin: PropTypes.bool,

  /** Button html type */
  type: PropTypes.string,

  /** Button size */
  size: PropTypes.oneOf(['small', 'medium', 'large'])
};
export default Button;